/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const TABLE_LABELS = {
  createdAt: "Date Created",
  createdBy: "Created By",
  updatedAt: "Date Updated",
  updatedBy: "Updated By",
  scope: "Scope",
  type: "Type",
};
